import { OrganizationsPanel } from '@juvare/contact-management/ui/features/organizations';
import React from 'react';

export const HanOrganizationsPanelNew: React.FC = () => {
    return <OrganizationsPanel />;
};
